var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { Listing } from '../../../classes/listing';
import { LoginSource } from '../../../classes/enums';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';
import { CredentialsService } from '../../../services/credentials.service';
import { HasSubscriptions } from '../../../components/has-subscriptions';
import { CurrencyPipe } from '@angular/common';
import { HomeEstimatorService } from "../../../services/home-estimator.service";
import { SCREEN_SIZE } from "../../../classes/enums";
import { debounceTime } from "rxjs/operators";
import { CommunicationService } from "../../../services/communication.service";
import { AllowedHveCities } from '../../../app-config.constants';
var EstimatedValueComponent = /** @class */ (function (_super) {
    __extends(EstimatedValueComponent, _super);
    function EstimatedValueComponent(homeEstimatorService, userService, router, communicationService, credentialsService, currencyPipe) {
        var _this = _super.call(this) || this;
        _this.homeEstimatorService = homeEstimatorService;
        _this.userService = userService;
        _this.router = router;
        _this.communicationService = communicationService;
        _this.credentialsService = credentialsService;
        _this.currencyPipe = currencyPipe;
        _this.retrievingEstimate = true;
        return _this;
    }
    Object.defineProperty(EstimatedValueComponent.prototype, "isMobile", {
        get: function () {
            return this.screenSize == SCREEN_SIZE.MOBILE_ONLY;
        },
        enumerable: true,
        configurable: true
    });
    EstimatedValueComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.communicationService.screenSize.pipe(debounceTime(50)).subscribe(function (screenSize) {
            _this.screenSize = screenSize;
        }));
        this.isAllowed = AllowedHveCities.includes(this.listing.city.toLowerCase());
        if (this.listing.isOffMarket && !this.userService.isGoogleBot()) {
            this.addSub(this.credentialsService.isLoggedIn.subscribe(function (isAuthenticated) {
                _this.isAuthenticated = isAuthenticated;
                if (isAuthenticated || _this.isAllowed) {
                    _this.homeEstimatorService.getOffMarketHomeEstimate(_this.listing.id).then(function (response) {
                        return _a = [_this.currencyPipe.transform(response.estimateRangeHigh, 'CAD', 'symbol-narrow', '1.0-0'), _this.currencyPipe.transform(response.estimateRangeLow, 'CAD', 'symbol-narrow', '1.0-0'), false], _this.estimateRangeHigh = _a[0], _this.estimateRangeLow = _a[1], _this.retrievingEstimate = _a[2], _a;
                        var _a;
                    });
                }
            }));
        }
    };
    EstimatedValueComponent.prototype.loginToView = function () {
        this.router.navigate(['/', { outlets: { popup: ['register-login', LoginSource.HomeEstimator] } }]);
    };
    return EstimatedValueComponent;
}(HasSubscriptions));
export { EstimatedValueComponent };
